//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  api_GetUsdtWithdrawInfo,
  api_BindUsdtAddress,
  api_CreateUsdtWithdraw,
  api_GetUsdtWithdrawHistory
} from "@/api";
import { mapMutations } from "vuex";

export default {
  name: "usdtWithdraw",
  data() {
    return {
      info: {
        isAllowUsdtWithdraw: false,
        availableAmount: 0,
        takeOutMin: 0,
        takeOutMax: 0,
        takeOutFeeRate: 0,
        address: "",
        chain: ""
      },
      bindModal: {
        show: false
      },
      bindForm: {
        address: "",
        chain: "TRC20",
        password: ""
      },
      withdrawForm: {
        amount: null,
        password: ""
      },
      historyModal: {
        show: false
      },
      history: {
        list: [],
        total: 0,
        current: 1,
        size: 10
      },
      binding: false,
      submitting: false
    };
  },
  computed: {
    amountMin() {
      return Number(this.info.takeOutMin || 0);
    },
    estimatedUsdtAmount() {
      const amount = Number(this.withdrawForm.amount || 0);
      const feeRate = Number(this.info.takeOutFeeRate || 0);
      if (amount <= 0 || feeRate < 0 || feeRate >= 100) return 0;

      return Number((amount * (100 - feeRate) / 100).toFixed(6));
    },
    amountLimitText() {
      const takeOutMax = Number(this.info.takeOutMax || 0);
      if (this.amountMin <= 0 && takeOutMax <= 0) return "";

      const minText = this.amountMin > 0 ? `${this.amountMin} USDT` : "不限";
      const maxText = takeOutMax > 0 ? `${this.info.takeOutMax} USDT` : "不限";
      return `${minText} - ${maxText}`;
    },
    canSubmit() {
      const amount = Number(this.withdrawForm.amount || 0);
      return this.info.isAllowUsdtWithdraw
        && this.info.address
        && amount > 0;
    }
  },
  created() {
    this.loadInfo();
  },
  methods: {
    ...mapMutations(["setInfo"]),
    loadInfo() {
      api_GetUsdtWithdrawInfo().then(res => {
        if (res.data.code === 0) {
          this.info = res.data.data || this.info;
        }
      });
    },
    openBindModal() {
      if (this.info.address) {
        this.$Message.info("已绑定");
        return;
      }

      this.bindForm.address = this.info.address || "";
      this.bindForm.chain = this.info.chain || "TRC20";
      this.bindForm.password = "";
      this.bindModal.show = true;
    },
    submitBind() {
      if (!this.bindForm.address) {
        this.$Message.error("请输入USDT地址");
        return;
      }
      if (!this.bindForm.password) {
        this.$Message.error("请输入登录密码");
        return;
      }

      this.binding = true;
      api_BindUsdtAddress(this.bindForm).then(res => {
        if (res.data.code === 0 || res.data.success) {
          this.$Message.success(res.data.msg || "绑定成功");
          this.bindModal.show = false;
          this.loadInfo();
        } else {
          this.$Message.error(res.data.msg);
        }
      }).finally(() => {
        this.binding = false;
      });
    },
    submitWithdraw() {
      if (!this.info.isAllowUsdtWithdraw) {
        this.$Message.error("当前账户暂不可提取USDT");
        return;
      }
      if (!this.info.address) {
        this.$Message.error("请先绑定USDT地址");
        return;
      }
      if (!this.withdrawForm.amount || this.withdrawForm.amount <= 0) {
        this.$Message.error("请输入提取数量");
        return;
      }
      if (!Number.isInteger(Number(this.withdrawForm.amount))) {
        this.$Message.error("提取数量必须为整数");
        return;
      }
      if (this.amountMin > 0 && Number(this.withdrawForm.amount) < this.amountMin) {
        this.$Message.error(`提取数量不能小于${this.amountMin}`);
        return;
      }
      if (Number(this.info.takeOutMax || 0) > 0 && Number(this.withdrawForm.amount) > Number(this.info.takeOutMax || 0)) {
        this.$Message.error(`提取数量不能大于${this.info.takeOutMax}`);
        return;
      }
      if (Number(this.withdrawForm.amount) > Number(this.info.availableAmount || 0)) {
        this.$Message.error("可提取余额不足");
        return;
      }
      if (!this.withdrawForm.password) {
        this.$Message.error("请输入登录密码");
        return;
      }

      this.submitting = true;
      api_CreateUsdtWithdraw(this.withdrawForm).then(res => {
        if (res.data.code === 0 || res.data.success) {
          this.$Message.success(res.data.msg || "提取申请成功");
          this.withdrawForm.amount = null;
          this.withdrawForm.password = "";
          this.loadInfo();
          this.setInfo();
        } else {
          this.$Message.error(res.data.msg);
        }
      }).finally(() => {
        this.submitting = false;
      });
    },
    openHistory() {
      this.historyModal.show = true;
      this.history.current = 1;
      this.loadHistory();
    },
    loadHistory() {
      api_GetUsdtWithdrawHistory({
        page: this.history.current,
        size: this.history.size
      }).then(res => {
        if (res.data.code === 0) {
          this.history.list = res.data.data.data || [];
          this.history.total = res.data.data.totalItems || 0;
        }
      });
    },
    historyPageChange(page) {
      this.history.current = page;
      this.loadHistory();
    },
    stateText(state) {
      if (state === 0) return "待处理";
      if (state === 1) return "已拒绝";
      if (state === 2) return "已完成";
      return "未知";
    }
  }
};
